import React from 'react';
import { CreditCard, Check, Download } from 'lucide-react';
import { AppShell } from '../components/AppShell';
export function BillingPage() {
  return <AppShell data-id="element-582">
      <div className="p-6 lg:p-8 max-w-5xl mx-auto space-y-8" data-id="element-583">
        <div data-id="element-584">
          <h1 className="text-2xl text-navy-950 mb-1" data-id="element-585">Facturación y Planes</h1>
          <p className="text-sm text-navy-600" data-id="element-586">
            Gestione su suscripción y métodos de pago.
          </p>
        </div>

        {/* Current Plan */}
        <div className="bg-white rounded-xl border border-slate-200 shadow-card overflow-hidden" data-id="element-587">
          <div className="p-6 sm:p-8 flex flex-col md:flex-row md:items-center justify-between gap-6" data-id="element-588">
            <div data-id="element-589">
              <div className="flex items-center gap-3 mb-2" data-id="element-590">
                <h2 className="text-lg font-semibold text-navy-950" data-id="element-591">
                  Plan Profesional
                </h2>
                <span className="text-[10px] font-bold uppercase tracking-wider text-brand-600 bg-brand-50 px-2 py-0.5 rounded-full border border-brand-100" data-id="element-592">
                  Plan Actual
                </span>
              </div>
              <p className="text-sm text-navy-600 mb-4" data-id="element-593">
                Facturado mensualmente. Próximo cobro: 15 Nov 2023
              </p>
              <div className="flex items-end gap-1" data-id="element-594">
                <span className="text-3xl font-light text-navy-950" data-id="element-595">$299</span>
                <span className="text-sm text-slate-400 mb-1" data-id="element-596">USD / mes</span>
              </div>
            </div>

            <div className="flex flex-col gap-3 min-w-[200px]" data-id="element-597">
              <button className="w-full bg-navy-950 hover:bg-navy-800 text-white text-sm font-medium px-4 py-2.5 rounded-md transition-colors shadow-sm" data-id="element-598">
                Hacer Upgrade a Enterprise
              </button>
              <button className="w-full bg-white hover:bg-slate-50 text-navy-950 border border-slate-200 text-sm font-medium px-4 py-2.5 rounded-md transition-colors" data-id="element-599">
                Cancelar Suscripción
              </button>
            </div>
          </div>

          <div className="bg-slate-50 border-t border-slate-200 p-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-600">
            <div className="flex flex-col" data-id="element-601">
              <span className="text-xs text-slate-400 mb-1" data-id="element-602">Asientos</span>
              <span className="text-sm font-medium text-navy-950" data-id="element-603">
                3 de 5 utilizados
              </span>
            </div>
            <div className="flex flex-col" data-id="element-604">
              <span className="text-xs text-slate-400 mb-1" data-id="element-605">
                Alertas Activas
              </span>
              <span className="text-sm font-medium text-navy-950" data-id="element-606">
                12 de 50
              </span>
            </div>
            <div className="flex flex-col" data-id="element-607">
              <span className="text-xs text-slate-400 mb-1" data-id="element-608">
                Búsquedas Semánticas
              </span>
              <span className="text-sm font-medium text-navy-950" data-id="element-609">
                Ilimitadas
              </span>
            </div>
            <div className="flex flex-col" data-id="element-610">
              <span className="text-xs text-slate-400 mb-1" data-id="element-611">
                Método de Pago
              </span>
              <span className="text-sm font-medium text-navy-950 flex items-center gap-2" data-id="element-612">
                <CreditCard size={14} className="text-slate-400" data-id="element-613" />
                •••• 4242
              </span>
            </div>
          </div>
        </div>

        {/* Billing History */}
        <div data-id="element-614">
          <h3 className="text-base font-medium text-navy-950 mb-4" data-id="element-615">
            Historial de Pagos
          </h3>
          <div className="bg-white rounded-xl border border-slate-200 shadow-card overflow-hidden" data-id="element-616">
            <table className="w-full text-left border-collapse" data-id="element-617">
              <thead data-id="element-618">
                <tr className="border-b border-slate-200 bg-slate-50/50" data-id="element-619">
                  <th className="py-3 px-4 text-xs font-semibold text-slate-400 uppercase tracking-wider" data-id="element-620">
                    Fecha
                  </th>
                  <th className="py-3 px-4 text-xs font-semibold text-slate-400 uppercase tracking-wider" data-id="element-621">
                    Monto
                  </th>
                  <th className="py-3 px-4 text-xs font-semibold text-slate-400 uppercase tracking-wider" data-id="element-622">
                    Estado
                  </th>
                  <th className="py-3 px-4 text-xs font-semibold text-slate-400 uppercase tracking-wider text-right" data-id="element-623">
                    Factura
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100" data-id="element-624">
                {[{
                date: '15 Oct 2023',
                amount: '$299.00',
                status: 'Pagado'
              }, {
                date: '15 Sep 2023',
                amount: '$299.00',
                status: 'Pagado'
              }, {
                date: '15 Ago 2023',
                amount: '$299.00',
                status: 'Pagado'
              }].map((invoice, i) => <tr key={i} className="hover:bg-slate-50 transition-colors" data-id="element-625">
                    <td className="py-3 px-4 text-sm text-navy-950 font-medium" data-id="element-626">
                      {invoice.date}
                    </td>
                    <td className="py-3 px-4 text-sm text-navy-600" data-id="element-627">
                      {invoice.amount}
                    </td>
                    <td className="py-3 px-4" data-id="element-628">
                      <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-bold uppercase tracking-wide bg-emerald-50 text-emerald-600" data-id="element-629">
                        <Check size={10} data-id="element-630" /> {invoice.status}
                      </span>
                    </td>
                    <td className="py-3 px-4 text-right" data-id="element-631">
                      <button className="text-slate-400 hover:text-brand-500 transition-colors p-1" data-id="element-632">
                        <Download size={16} data-id="element-633" />
                      </button>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </AppShell>;
}